import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faShoppingCart,
  faTags
} from "@fortawesome/free-solid-svg-icons";

export const InCartButton = () => {
  return (
    <Button
      className="products__result-cart"
      id="inCartButton"
      color="primary"
      outline
      size="sm"
      disabled
    >
      <FontAwesomeIcon
        icon={faShoppingCart}
        className="me-2"
        id="shoppingCartIcon"
      />
      <span>In Cart</span>
    </Button>
  );
};

export const AddToCartButton = ({ onCartAdd, sku, id, price, setAdded }) => {
  return (
    <Button
      className="products__result-cart"
      id="addToCartButton"
      color="primary"
      size="sm"
      onClick={() => {
        onCartAdd(sku, id, price);
        setAdded(true);
      }}
    >
      <FontAwesomeIcon icon={faCartPlus} className="me-2" />
      <span>Add to Cart</span>
    </Button>
  );
};

AddToCartButton.propTypes = {
  onCartAdd: PropTypes.func,
  setAdded: PropTypes.func,
  sku: PropTypes.string,
  id: PropTypes.number,
  price: PropTypes.number
};

AddToCartButton.defaultProps = {
  onCartAdd: undefined,
  setAdded: undefined,
  sku: null,
  id: null,
  price: null
};

export const GetQuoteButton = ({ name, sku }) => {
  return (
    <a
      className="enterprisePricing__link"
      href={`/request-pricing/name=${name}sku=${sku}`}
      rel="origin-when-cross-origin"
    >
      <FontAwesomeIcon icon={faTags} alt="tags icon" className="me-2" />
      Request an Enterprise Quote
    </a>
  );
};

GetQuoteButton.propTypes = {
  name: PropTypes.string,
  sku: PropTypes.string
};

GetQuoteButton.defaultProps = {
  name: null,
  sku: null
};
